
import ProfileHeader from "@/components/ProfileHeader.vue";
export default {
  name: "profileLayout",
  components: {
    ProfileHeader,
  },
  async mounted(){
    await this.$store.dispatch("store/retrieveSettings");
    this.$nextTick(() => {
      this.loaded = true
    })
  },
  computed: {
    isMobile() {
      return this.isClient && window.innerWidth <= 768; // Specify the desired device width threshold
    },
    isClient() {
      return process.client; // Check if code is running on the client-side
    },
  }
}
